import { useEffect, useRef } from 'react'

import { Icon } from '@mui/material'
import Map, { MapRef, Marker } from 'react-map-gl/mapbox'

import LoadingComponent from 'modules/Loading'

import 'mapbox-gl/dist/mapbox-gl.css'

interface Props {
	lat: number
	lng: number
	resetKey?: boolean | string | number
	onGeometryChange: (lat: number, lng: number) => void
}

function PayphoneMap({ lat, lng, resetKey, onGeometryChange }: Props): JSX.Element {
	const mapRef = useRef<MapRef>(null)
	const isMapFirstRenderRef = useRef(true)

	useEffect(() => {
		isMapFirstRenderRef.current = true
	}, [resetKey])

	useEffect(() => {
		const map = mapRef.current
		if (!map || Number.isNaN(lat) || Number.isNaN(lng)) return

		const center: [number, number] = [lng, lat]
		if (isMapFirstRenderRef.current) {
			map.jumpTo({ center, zoom: 16 })
		} else {
			map.flyTo({ center, zoom: 16 })
		}
	}, [lat, lng])

	if (lng === undefined || lat === undefined || Number.isNaN(lat) || Number.isNaN(lng)) {
		return <LoadingComponent type="box" height={280} />
	}

	return (
		<Map
			ref={mapRef}
			mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
			mapStyle="mapbox://styles/mapbox/streets-v11"
			initialViewState={{ longitude: lng, latitude: lat, zoom: 16 }}
			style={{ height: '280px', width: '100%', borderRadius: '12px' }}
			onLoad={() => {
				isMapFirstRenderRef.current = false
			}}
			onClick={(e) => {
				const { lng: clickLng, lat: clickLat } = e.lngLat
				onGeometryChange(Number(clickLat.toFixed(6)), Number(clickLng.toFixed(6)))
			}}
		>
			<Marker longitude={lng} latitude={lat} anchor="bottom">
				<Icon color="error" fontSize="large">
					location_on
				</Icon>
			</Marker>
		</Map>
	)
}

export default PayphoneMap
